module.exports = __webpack_public_path__ + "static/media/298524.a9ae3460.png";